import styled, { css } from 'styled-components';
import { hexWithOpacity } from 'shared-ui';

import { DodStateTone } from '../stateChip/StateChip.types';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const RcpLabel = styled.div(
  ({ theme: { palette } }) => css`
    width: 140px;
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: ${palette.grey[700]};
  `,
);

export const Grid = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Legend = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const LegendItem = styled.span(
  ({ theme: { palette } }) => css`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: ${palette.grey[700]};
  `,
);

export const LegendSwatch = styled.span<{ $tone: DodStateTone }>(({ theme: { palette }, $tone }) => {
  const color = toneColor(palette.chart, palette.primary.main, $tone);

  return css`
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background-color: ${hexWithOpacity(color, 0.12)};
    border: 1px solid ${color};
  `;
});

export const toneColor = (
  chart: { ok: string; warn: string; bad: string; neutral: string },
  primary: string,
  tone: DodStateTone,
): string => {
  if (tone === 'ok') {
    return chart.ok;
  }

  if (tone === 'warn') {
    return chart.warn;
  }

  if (tone === 'bad') {
    return chart.bad;
  }

  if (tone === 'info') {
    return primary;
  }

  return chart.neutral;
};

export const Cell = styled.button<{ $tone: DodStateTone }>(({ theme: { palette }, $tone }) => {
  const color = toneColor(palette.chart, palette.primary.main, $tone);

  return css`
    width: 96px;
    height: 56px;
    border-radius: 6px;
    background-color: ${hexWithOpacity(color, 0.12)};
    border: 1px solid ${color};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    font-family: inherit;
    color: ${palette.text.secondary};
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${palette.primary.main};
      outline-offset: 2px;
    }
  `;
});

export const CellName = styled.span`
  font-size: 12px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellValue = styled.span`
  font-family: ui-monospace, Menlo, monospace;
  font-size: 16px;
  font-weight: 700;
`;
